module.exports = __webpack_public_path__ + "static/media/low_visibility_1.490cdee0.png";